<template>
  <b-form-group
    label="Proje Servisleri"
    label-for="project_services"
  >
    <validation-provider
      #default="{ errors }"
      name="Proje Servisleri"
    >
      <v-select
        id="id"
        v-model="dataItem.project_services"
        :options="dataList"
        label="title"
        placeholder="Proje Servisleri"
        multiple
      >
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>

        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
    <!--    <pre>-->
    <!--      {{ dataItem }}-->
    <!--    </pre>-->
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
  BCard,
  BCardHeader,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProjectServices',
  components: {
    BFormGroup,
    vSelect,
    BCard,
    BCardHeader,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BButton,
    ValidationProvider,
  },
  data() {
    return {
      required,
      project_services: [],
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['projectServices/dataList']
    },
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('projectServices/getDataList', {
        select: [
          'project_services.id AS id',
          'project_services.title AS title',
        ],
      })
    },
  },

}
</script>
